import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useAddLocalTransportRuleMutation } from "store/services/LocalTransportRuleApi";
import LocalTransportRuleForm from "./LocalTransportRuleComponents/LocalTransportRuleForm";

const LocalTransportRuleCreateScreen = () => {
  const navigate = useNavigate();
  const [addRule, { isLoading }] = useAddLocalTransportRuleMutation();

  const handleSubmit = async (data) => {
    try {
      await addRule(data).unwrap();
      toast.success("Rule created!");
      navigate("/app/crm/local-transport-rule/list");
    } catch (err) {
      toast.error(err?.data?.message || "Failed to create rule");
    }
  };

  return (
    <BreadcrumbLayout
      breadcrumbs={[
        {
          title: "Local Transport Rules",
          path: "/app/crm/local-transport-rule/list",
        },
        { title: "New Rule" },
      ]}
    >
      <BreadcrumbLayout.Paper>
        <LocalTransportRuleForm isBusy={isLoading} onSubmit={handleSubmit} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default LocalTransportRuleCreateScreen;
